const initialState = {
    config: null,
    isConfigLoading: false,
    error: null
};

export default (state = initialState, action) => {
    const { type } = action;

    switch (type) {
        case 'AI_CONFIG:LOADING':
            return {
                ...state,
                isConfigLoading: true,
                error: null
            };

        case 'AI_CONFIG:LOADED':
            return {
                ...state,
                isConfigLoading: false,
                config: action.payload,
                error: null
            };

        case 'AI_CONFIG:ERROR':
            return {
                ...state,
                isConfigLoading: false,
                error: action.payload
            };

        default:
            return state;
    }
};
